import api from "./api";

export const getPartnerAds = async () => {
    try {
        const response = await api.get(`/partner-ads?populate=*`);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getSinglePartnerAd = async (id) => {
    try {
        const response = await api.get(`/partner-ads/${id}?populate=*`);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const countPartnerAds = async () => {
    try {
        const response = await getPartnerAds();
        const length = response.length;
        return length;
    } catch (e) {
        console.error(e);
    }
};

export const getFilteredPartnerAds = async (filters = {}, page = 1, pageSize = 12) => {
    try {
        // console.log(filters)
        const queryParams = {
            populate: '*',
            filters: {},
            pagination: {
                page,
                pageSize
            }
        };

        // Add search term if provided
        if (filters.search) {
            queryParams.filters.$or = [
                {
                    title: {
                        $containsi: filters.search
                    }
                },
                {
                    subtitle: {
                        $containsi: filters.search
                    }
                }
            ];
        }

        // Add active filter if provided
        if (filters.isActive !== undefined) {
            queryParams.filters.isActive = {
                $eq: filters.isActive
            };
        }

        // Add sorting if provided
        if (filters.sort) {
            queryParams.sort = [filters.sort];
        }

        const response = await api.get('/partner-ads', { params: queryParams });
        return {
            data: response.data.data,
            pagination: response.data.meta.pagination
        };
    } catch (e) {
        console.error(e);
        return {
            data: [],
            pagination: {
                page: 1,
                pageSize: pageSize,
                pageCount: 0,
                total: 0
            }
        };
    }
};

export const deletePartnerAd = async (id) => {
    try {
        const response = await api.delete(`/partner-ads/${id}`);
        return true;
    } catch (err) {
        console.error('Error deleting partner ad:', err);
        return false
    }
};